var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1764 12.5978L16.0336 10.9234C15.7935 10.5502 15.5764 9.8442 15.5764 9.43066V6.87884C15.5764 4.50856 13.9993 2.46105 11.725 1.50285C11.1307 0.574917 10.0335 0 8.77641 0C7.53069 0 6.41074 0.59509 5.81645 1.53311C3.58788 2.51148 2.04502 4.53882 2.04502 6.87884V9.43066C2.04502 9.8442 1.82788 10.5502 1.58788 10.9133L0.433595 12.5978C-0.0235477 13.2735 -0.126405 14.0199 0.15931 14.7058C0.433595 15.3816 1.08502 15.9061 1.93074 16.1582C4.14788 16.8239 6.47931 17.1467 8.81069 17.1467C11.1421 17.1467 13.4735 16.8239 15.6907 16.1683C16.4907 15.9363 17.1078 15.4017 17.405 14.7058C17.7021 14.0098 17.6221 13.2433 17.1764 12.5978Z",
    fill: "#555454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0236 18.1654C11.5436 19.3354 10.275 20.1726 8.78927 20.1726C7.88642 20.1726 6.99499 19.8498 6.36641 19.2749C6.00069 18.9723 5.72641 18.5689 5.56641 18.1553C5.71498 18.1755 5.86355 18.1856 6.02355 18.2058C6.28641 18.236 6.5607 18.2663 6.83499 18.2865C7.48642 18.3369 8.14927 18.3671 8.81213 18.3671C9.46356 18.3671 10.115 18.3369 10.755 18.2865C10.995 18.2663 11.235 18.2562 11.4636 18.2259C11.6464 18.2058 11.8293 18.1856 12.0236 18.1654Z",
    fill: "#555454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 6.25842,
    r: 2.5,
    fill: "#FF5A5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.25e2113dda875c6b9a97d56bee973f37.svg";
export { ForwardRef as ReactComponent };